import { encode } from "html-entities"

export function escapeHTML(text: string): string {
  return encode(text)
}
